export default "__VITE_ASSET__f3dc022a__"